



























































































import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters, mapMutations, mapState } from 'vuex';
import { RootState } from '@/store';
import { TemplateContentGetters } from '@/features/template-content/template-content-store';
import { RoleGetters } from '@/store/roles';
import { TemplateDetailActions, TemplateDetailHelper } from '@/store/templates/template-detail';
import { copyTextToClipboard, openUrlInNewTab } from '@/utils/util';
import { createForTemplate, FileStorage } from '@/model/FileStorage';
import { normalizeTemplateContentOrder, Template, TEMPLATE_LAYOUTS } from '@/model/Template';
import FileUpload from '@/components/common/FileUpload.vue';
import draggable from 'vuedraggable';
import TemplateContentLinkBadges from '@/components/templates-detail/TemplateContentLinkBadges.vue';

@Component({
  components: { FileUpload, draggable, TemplateContentLinkBadges },
  computed: {
    ...mapState<RootState>({
      template: (state: RootState) => state.templates.template,
      templateContents: (state: RootState) => Object.values(state.templateContents.templateContents),
      roles: (state: RootState) => [{ id: '', name: '# No Role' }, ...Object.values(state.roles.roles)],
    }),
    ...mapGetters({
      getTemplateContentByIdOrEmpty: TemplateContentGetters.TEMPLATE_CONTENT_BY_ID_OR_EMPTY,
      getRoleByIdOrEmpty: RoleGetters.ROLE_BY_ID_OR_EMPTY
    }),
  },
  methods: {
    ...mapMutations({
      ...TemplateDetailHelper.setterForTemplateFields('name', 'description', 'documentKey', 'reviewerRoleId', 'releaserRoleId', 'location', 'layout', 'createdTemplateContentIds', 'reportedTemplateContentIds', 'templateContentOrder'),
    })
  }
})
export default class TemplateDetailDialog extends Vue {
  template: Template;
  setCreatedTemplateContentIds: (ids: string[]) => void;
  setReportedTemplateContentIds: (ids: string[]) => void;
  setTemplateContentOrder: (ids: string[]) => void;
  rules = [
    (value: string) => (!!value && value.length >= 1) || 'Minimum 1 character',
  ];
  valid = false;
  editDialog = false;
  layouts = TEMPLATE_LAYOUTS;

  get fileStorage(): FileStorage {
    return createForTemplate(this.template.versionId);
  }

  get orderedTemplateContentIds(): string[] {
    return normalizeTemplateContentOrder(this.template);
  }

  set orderedTemplateContentIds(ids: string[]) {
    this.setTemplateContentOrder(ids);
  }

  updateCreatedTemplateContentIds(ids: string[]) {
    this.setCreatedTemplateContentIds(ids);
    this.setTemplateContentOrder(normalizeTemplateContentOrder(this.template));
  }

  updateReportedTemplateContentIds(ids: string[]) {
    this.setReportedTemplateContentIds(ids);
    this.setTemplateContentOrder(normalizeTemplateContentOrder(this.template));
  }

  save() {
    this.$store.dispatch(TemplateDetailActions.TEMPLATE_DETAIL_SAVE)
        .then(() => this.editDialog = false);
  }

  cancel() {
    this.$store.dispatch(TemplateDetailActions.TEMPLATE_DETAIL_CANCEL)
        .then(() => this.editDialog = false);
  }

  copyToClipboard(text: string) {
    copyTextToClipboard(text);
  }

  openLink(url: string) {
    openUrlInNewTab(url);
  }

}
